import React, { ReactNode } from "react";
import Content from "./Content";
import Slider from "../Slider/index";
import HeaderWithIntro from "./HeaderWithIntro";

interface Props {
  headline: string;
  copy?: string;
  small?: boolean;
  children?: ReactNode | ReactNode[];
  leftIndented?: boolean;
  ariaLabel: string;
  padded?: boolean;
}

export default function SliderWithInfo(props: Props) {
  const {
    small,
    headline,
    children,
    copy,
    leftIndented,
    ariaLabel,
    padded
  } = props;
  if (!children) return null;
  return (
    <Content padded leftIndented={leftIndented}>
      <HeaderWithIntro
        headline={headline}
        intro={copy}
        size={small ? 4 : 1}
        boldHeadline={small}
        blue
        small
      />

      <Slider
        itemCountXLarge={small ? 2 : 3}
        itemCountLarge={small ? 2 : 3}
        itemCountMedium={small ? 2 : 2}
        itemCountSmall={1}
        ariaLabel={ariaLabel}
        padded={padded}
      >
        {children}
      </Slider>
    </Content>
  );
}
